module.exports = __webpack_public_path__ + "images/file_icons_v2/ged-dc4404b9de45b819ad28d5cfde885dbb.svg";